import * as api from '../resources/banners.api';
import actionTypes from './action-types';


export const fetchBannersRequest = () => ({
  type: actionTypes.FETCH_BANNERS_REQUEST,
  isLoading: true,
});

export const fetchBannersSuccess = (result, locales) => ({
  type: actionTypes.FETCH_BANNERS_SUCCESS,
  result,
  locales,
  isLoading: false,
});

export const fetchBannersFailure = () => ({
  type: actionTypes.FETCH_BANNERS_FAILURE,
  isLoading: false,
});

export const fetchBanners = (home = false) => async (dispatch, getState) => {
  try {
    const { config } = getState();
    const { locales, secondHandApproval, jurisdictionId } = config;

    dispatch(fetchBannersRequest());
    const result = await api.fetchBanners(secondHandApproval, jurisdictionId, home);
    dispatch(fetchBannersSuccess(result, locales));
  } catch (error) {
    console.error('FETCH_BANNERS', error);
    dispatch(fetchBannersFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/banners.actions.js